import React from "react";
import "../../assets/css/loader.css";

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <span className="loader"></span>
    </div>
  );
};

export default Loader;
